var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.46 4.54a.65.65 0 0 1 0 .92l-5.89 5.89H19a.65.65 0 1 1 0 1.3H6.57l5.89 5.89a.65.65 0 1 1-.92.92l-7-7a.65.65 0 0 1 0-.92l7-7a.65.65 0 0 1 .92 0Z",
    fill: "currentColor"
  })));
};

export { Svg24 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMi40NTk2IDQuNTQwMzhDMTIuNzEzNSA0Ljc5NDIyIDEyLjcxMzUgNS4yMDU3OCAxMi40NTk2IDUuNDU5NjJMNi41NjkyNSAxMS4zNUgxOUMxOS4zNTkgMTEuMzUgMTkuNjUgMTEuNjQxIDE5LjY1IDEyQzE5LjY1IDEyLjM1OSAxOS4zNTkgMTIuNjUgMTkgMTIuNjVINi41NjkyNUwxMi40NTk2IDE4LjU0MDRDMTIuNzEzNSAxOC43OTQyIDEyLjcxMzUgMTkuMjA1OCAxMi40NTk2IDE5LjQ1OTZDMTIuMjA1OCAxOS43MTM1IDExLjc5NDIgMTkuNzEzNSAxMS41NDA0IDE5LjQ1OTZMNC41NDAzOSAxMi40NTk2QzQuMjg2NTUgMTIuMjA1OCA0LjI4NjU1IDExLjc5NDIgNC41NDAzOSAxMS41NDA0TDExLjU0MDQgNC41NDAzOEMxMS43OTQyIDQuMjg2NTQgMTIuMjA1OCA0LjI4NjU0IDEyLjQ1OTYgNC41NDAzOFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";